var map = {
	"./calendar.html": 32,
	"./calendarDayView.html": 33,
	"./calendarHourList.html": 34,
	"./calendarMonthCell.html": 35,
	"./calendarMonthCellEvents.html": 36,
	"./calendarMonthView.html": 37,
	"./calendarSlideBox.html": 38,
	"./calendarWeekView.html": 39,
	"./calendarYearView.html": 40
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9;



//////////////////
// WEBPACK FOOTER
// ./src/templates nonrecursive \.html
// module id = 9
// module chunks = 0